export default __webpack_public_path__ + "static/onze_aanpak_4-364e6ebb9b79560bc495d1b69d291322.jpg";